module.exports = __webpack_public_path__ + "static/ballerinamousehamper-41ba7dd69440e1e9040a2f69f2011063.jpeg";